module.exports = __webpack_public_path__ + "img/Warped Band.9d6a6bce.png";